<div class="grouped-bar-chart-content" *ngIf="getSortedDataKeysLength() > 0; else noDataTemplate">
  <div
    echarts
    (chartInit)="onChartInit($event)"
    (chartClick)="onChartClick(field, $event)"
    [initOpts]="initOption"
    [options]="chartOption"
    [autoResize]="true"
    [ngClass]="{
      'grouped-bar-chart-small-chart-container': kpiChartSize === 'small',
      'grouped-bar-chart-medium-chart-container-with-toggle':
        kpiChartSize === 'medium' && includeToggleInHeightCalculation,
      'grouped-bar-chart-medium-chart-container': kpiChartSize === 'medium',
      'grouped-bar-chart-large-chart-container': kpiChartSize === 'large'
    }"
    [style.height]="getChartHeight()"
  ></div>
</div>
<ng-template #noDataTemplate>
  <drilldown-chart-no-data-available [size]="kpiChartSize"></drilldown-chart-no-data-available>
</ng-template>
